// The colour of an item's dot in the action point's item list (KEY-794).

import type { GeneratedStatus } from "@keydials/api-client";

/** Grey: unset, not counted, or not scored by any check. Matches StatusPicker's UNSET. */
export const UNSET_DOT = "#94a3b8";

/**
 * The least-advanced status across the checks that score an item, or grey when the item is N/A, when any of
 * them has no status yet — or when no check scores it at all. That last case is real: an item added on a
 * dial whose checks are scoped to particular items is scored by none, and reducing an empty list without a
 * starting value threw and blanked the whole page (KEY-794).
 */
export function itemDotColour(scoredStatuses: readonly (GeneratedStatus | undefined)[], excluded: boolean): string {
  if (excluded || scoredStatuses.length === 0 || scoredStatuses.some((s) => !s)) return UNSET_DOT;
  return (scoredStatuses as GeneratedStatus[]).reduce((a, b) => (a.order <= b.order ? a : b)).colour;
}
